import { TextField, Text } from "@radix-ui/themes";
import { t } from "i18next";
import _ from "lodash";
import { DateTime } from "luxon";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import ErrorsBlock from "../../../components/errors/ErrorsBlock";
import { userStatuses } from "../../../enums";
import { times } from "../../../enums/times";
import { useFetch } from "../../../hooks/useFetch";
import { useAppStore } from "../../../stores/RootStore";
import { AdminSensorType, DeviceModel, FShift, SelectOption, Shift, UserCompact } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { Label } from "../../../ui/Label/Label";
import MultipleSelector from "../../../ui/MultipleSelector/MultipleSelector";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { SelectButton } from "../../../ui/SelectButton/SelectButton";
import Spinner from "../../../ui/Spinner/Spinner";

const AddModel = () => {
  const [models, setModels, sensors] = useOutletContext<[DeviceModel[], Function, SelectOption[]]>();

  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      name: "",
      slot_1: [],
      slot_2: [],
      slot_3: [],
      slot_4: [],
    },
  });

  const [{ response: saveResponse, isLoading: saveIsLoading, error: saveError }, doFetchItemSave] = useFetch(
    `/administration/directories/device_models`,
    true
  );

  const onSubmit = (formData: any) => {
    setErrors([]);
    const slots = [];
    if (formData.slot_1.length > 0) slots.push({ number: 1, sensors: formData.slot_1.map((item: SelectOption) => item.value) });
    if (formData.slot_2.length > 0) slots.push({ number: 2, sensors: formData.slot_2.map((item: SelectOption) => item.value) });
    if (formData.slot_3.length > 0) slots.push({ number: 3, sensors: formData.slot_3.map((item: SelectOption) => item.value) });
    if (formData.slot_4.length > 0) slots.push({ number: 4, sensors: formData.slot_4.map((item: SelectOption) => item.value) });
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          name: formData.name,
          structure: {
            slots: slots,
          },
        },
      },
    });
    reset();
  };

  const AddSensor = (itemSaveResponse: { data: unknown }) => {
    const newUserData = itemSaveResponse.data as unknown as DeviceModel;
    setModels([...models, newUserData].sort((a, b) => Number(a.id) - Number(b.id)));
  };

  useEffect(() => {
    if (!saveResponse) return;
    AddSensor(saveResponse);
  }, [saveResponse]);

  useEffect(() => {
    if (!saveError) return;
    setErrors(saveError.errors);
    console.log(saveError);
  }, [saveError]);

  return (
    <ScrollArea className="w-full">
      <div className="flex flex-col max-w-[900px] w-full justify-start mx-auto pl-4 pr-16 relative overflow-hidden my-[4rem]">
        <div className="text-xl font-semibold">{t("adding_equipment_device_sensor")}</div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col w-full pt-8 h-full gap-3">
            {errors ? <ErrorsBlock errors={errors} /> : ""}
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("title_name")}*`} />
                </div>
              )}
            />
            <Controller
              name="slot_1"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Label>{t("sensors_for_slot 1")}*</Label>
                  <MultipleSelector
                    value={field.value}
                    onChange={field.onChange}
                    defaultOptions={sensors}
                    groupBy="test"
                  />
                </div>
              )}
            />
            <Controller
              name="slot_2"
              control={control}
              //rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Label>{t("sensors_for_slot 2")}</Label>
                  <MultipleSelector value={field.value} onChange={field.onChange} defaultOptions={sensors} />
                </div>
              )}
            />
            <Controller
              name="slot_3"
              control={control}
              //rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Label>{t("sensors_for_slot 3")}</Label>
                  <MultipleSelector value={field.value} onChange={field.onChange} defaultOptions={sensors} />
                </div>
              )}
            />
            <Controller
              name="slot_4"
              control={control}
              //rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Label>{t("sensors_for_slot 4")}</Label>
                  <MultipleSelector value={field.value} onChange={field.onChange} defaultOptions={sensors} />
                </div>
              )}
            />
            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddModel;
